<template>
    <div class="page-wrapper edna-home">

        <div class="page-heading">
            <div class="container">
                <div class="row justify-content-center text-center edna-heading">
                    <div class="col-12 col-lg-10">
                        <h1 class="mt-3">MEET EDNA 1.0</h1>
                        <p class="subtitle">ENDA 1.0 is Enterprise DNA's chat bot who is programmed to help you look for
                            possible answers for your Power BI and DAX queries. Enjoy chatting with her.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-8">
                    <iframe class="edna-iframe" width="100%" height="450" frameBorder="0"
                            src="https://botmake.io/enterprisedna?preview=yes"></iframe>
                </div>
            </div>
        </div>

        <div class="full-width-blue-section footer-area">
            <div class="container text-center">

                <div class="buttons-wrap align-content-between">
                    <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=rsY_vVWk6kqj2yh50iUzho5j7vgUJDNNuzPlBaBDJcdURE03SUNDM0xaV0I5SkVEV1hQRUY2U0hIVS4u"
                       class="btn btn-white mt-2" target="_blank">Let us know your feedback</a>
                    <a href="https://forum.enterprisedna.co/search" class="btn btn-white mt-2" target="_blank">Search Enterprise DNA
                        Forum</a>
                </div>

                <p class="text-center text-white">EDNA is getting smarter everyday with 4558 known keywords
                    currently</p>
            </div>
        </div>

<!--        <div class="footer-area">-->
<!--            <div class="container ">-->
<!--                <div class="align-content-between ">-->
<!--                    <a href="#" class="btn btn-primary">Let us know your feedback</a>-->
<!--                    <a href="#" class="btn btn-primary">Search Enterprise DNA Forum</a>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="container ">-->
<!--                <p class="text-center text-white">EDNA is getting smarter everyday with 4558 known keywords-->
<!--                    currently</p>-->
<!--            </div>-->
<!--        </div>-->

    </div>
</template>

<script>
export default {
    name: "EDNA"
}
</script>

<style scoped>

</style>
